import axios from 'axios';
import getVisitorUuid from '@menu/Utils/getVisitorUuid';
import getRestaurant from '@menu/Utils/getRestaurant';

export default () => {
  // Menu previews inside the dashboard aren't real visits.
  if (new URLSearchParams(location.search).get('iframe_preview') === '1') {
    return;
  }

  axios
    .post(`/api/menu-visits`, {
      restaurantId: getRestaurant().id,
      meta: {
        document: {
          referrer: document.referrer,
        },
        location: {
          href: location.href,
        },
        navigator: {
          language: navigator.language,
          languages: navigator.languages,
          maxTouchPoints: navigator.maxTouchPoints,
          standalone:
            (navigator as Navigator & { standalone?: boolean }).standalone ??
            null,
        },
        window: {
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight,
        },
        matchMedia: {
          '(display-mode: standalone)': window.matchMedia(
            '(display-mode: standalone)',
          ).matches,
        },
        uuid: getVisitorUuid(),
      },
    })
    .finally(() => {});
};
